import hr from './qr-preview-hr.png';
import gr from './qr-preview-gr.png';
import it from './qr-preview-it.png';
import tr from './qr-preview-tr.png';

export default { hr, gr, it, tr };
